import type { ApolloQueryResult } from 'apollo-client';

import type { Metadata } from '@atlaskit/editor-common/collab';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient.ts';

import { CollabDraftQuery } from './CollabDraftQuery.graphql.ts';
import type {
	CollabDraftQuery as CollabDraftQueryRes,
	CollabDraftQueryVariables,
} from './__types__/CollabDraftQuery.ts';

export type InitialDraft = {
	document: any;
	version: number;
	metadata?: Metadata;
};

export type FetchDraft = {
	draft: InitialDraft | null;
	response?: Response | ApolloQueryResult<any>;
	error?: Error;
};

export async function fetchDraft(contentId: string, draftShareId?: string): Promise<FetchDraft> {
	// eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
	const response = await getApolloClient().query<CollabDraftQueryRes, CollabDraftQueryVariables>({
		query: CollabDraftQuery,
		variables: {
			id: contentId,
			hydrateAdf: true,
			...(draftShareId ? { draftShareId } : undefined),
		},
		fetchPolicy: window.__SSR_RENDERED__ ? 'cache-first' : 'network-only',
	});
	const { data, errors } = response;

	if (errors || !data.collabDraft) {
		return { draft: null, response };
	}

	const { document, version, metadata } = data.collabDraft;

	const draft = {
		version,
		metadata: excludeTypename(metadata),
		document: JSON.parse(document || ''),
	} as InitialDraft;

	return { draft, response };
}

function excludeTypename(
	metadata?: Record<string, any> | null,
): Record<string, any> | null | undefined {
	if (!metadata) return metadata;
	const { __typename, ...rest } = metadata;
	return rest;
}
